import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';

const tiles = [
	{
		title: 'Allocation Report',
		icon: '📊',
		description: 'View allocation trends, durations, and discount analytics.',
		permissions: ['view_allocations'],
		url: 'allocations',
	},
	{
		title: 'Payment Analytics',
		icon: '💰',
		description: 'View payment timing, methods, and comprehensive analytics.',
		permissions: ['view_payments'],
		url: 'payment-analytics',
	},
	{
		title: 'Rent Collection Report',
		icon: '🏠',
		description: 'Track rent invoices by month, view paid/unpaid status and collection summary.',
		permissions: ['view_payments'],
		url: 'rent-collection',
	},
	{
		title: 'Complaints Report',
		icon: '📋',
		description: 'View complaints by type, staff resolutions, and building analytics.',
		permissions: ['view_complaints'],
		url: 'complaints',
	},
	{
		title: 'WhatsApp Logs',
		icon: '📱',
		description: 'View WhatsApp message logs and delivery status.',
		permissions: ['view_whatsapp_logs'],
		url: 'whatsapp-logs',
	},
	{
		title: 'Background Jobs',
		icon: '⚙️',
		description: 'View background job status, history, and detailed results.',
		permissions: ['view_jobs'],
		url: 'jobs',
	}
];

const ReportManagement = () => {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<div className="rt-layout">
			<Menu className="rt-menu" activePath={location.pathname} />
			<div className="rt-main-content">
				<div className="rt-title-row">
					<h2 className="rt-title">Reports Management</h2>
				</div>
				<div className="rt-main-section">
					<div className="rt-tiles-grid">
						{tiles.map((tile, idx) => (
							<Tile
								key={idx}
								title={tile.title}
								icon={tile.icon}
								description={tile.description}
								access_roles={['RT_Admin']}
								onClick={() => tile.url && navigate(tile.url)}
								tabIndex={0}
								role="button"
								onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReportManagement;
